import type { PropsWithChildren, ReactNode } from "react";
import { motion, useReducedMotion } from "motion/react";

type PageFrameProps = PropsWithChildren<{
  className?: string;
  label?: string;
  title?: string;
  intro?: ReactNode;
}>;

export function PageFrame({ children, className = "", label, title, intro }: PageFrameProps) {
  const reduceMotion = useReducedMotion();

  return (
    <motion.main
      id="main-content"
      className={`page ${className}`.trim()}
      initial={reduceMotion ? false : { opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={reduceMotion ? undefined : { opacity: 0 }}
      transition={{ duration: 0.28 }}
    >
      {title ? (
        <header className="page-intro technical-frame">
          {label ? <p className="technical-label">{label}</p> : null}
          <h1>{title}</h1>
          {intro ? <div className="page-intro-copy">{intro}</div> : null}
        </header>
      ) : null}
      {children}
    </motion.main>
  );
}
